import { cloneDeep, merge } from 'lodash';
import { useEffect, useState } from 'react';
import useTenantConfigData from './useTenantConfigData';

interface BaseComponentConfig {
  inherits?: string;
  [key: string]: any; // Allows for additional, unspecified properties
}

interface TaskFormConfig extends BaseComponentConfig {
  priority?: {
    hide?: boolean;
    valueSetIdentifier?: string;
    defaultValueCode?: string;
  };
}

interface TaskFormFromPatientDetailsConfig extends TaskFormConfig {
  inherits: 'taskFormConfig';
}

interface AppointmentFormConfig extends BaseComponentConfig {
  reason?: {
    hide?: boolean;
    valueSetIdentifier?: string;
    defaultValueCode?: string;
  };
  reasonText?: {
    hide?: boolean;
  };
}

interface AppointmentListConfig extends BaseComponentConfig {
  reasonColumn?: {
    hide?: boolean;
  };
  reasonTextColumn?: {
    hide?: boolean;
  };
}

export interface ComponentsConfig {
  taskFormConfig?: TaskFormConfig;
  taskFormFromPatientDetailsConfig?: TaskFormFromPatientDetailsConfig;
  appointmentFormConfig?: AppointmentFormConfig;
  appointmentListConfig?: AppointmentListConfig;
}

function resolveComponentsConfig(allConfigs: any): any {
  if (!allConfigs) {
    console.warn(`allConfigs not found.`);
    return {};
  }

  let resolvedConfig = cloneDeep(allConfigs);

  Object.keys(allConfigs).forEach((key) => {
    if (allConfigs[key].inherits && allConfigs[allConfigs[key].inherits]) {
      merge(resolvedConfig[key], allConfigs[allConfigs[key].inherits]);
      merge(resolvedConfig[key], allConfigs[key]);
    }
  });

  console.debug('resolveComponentsConfig -> resolvedConfig: ', resolvedConfig);

  return resolvedConfig as ComponentsConfig;
}

const useComponentsConfigData = (): ComponentsConfig => {
  const tenantConfigData = useTenantConfigData();
  const [data, setData] = useState<ComponentsConfig>({});

  useEffect(() => {
    if (tenantConfigData.componentsConfigData) {
      const resolvedData = resolveComponentsConfig(tenantConfigData.componentsConfigData);
      setData(resolvedData);
    }
  }, [tenantConfigData]);

  return data;
};

export default useComponentsConfigData;
